import React, { useEffect, useState } from 'react';
import ZipCode from '../Home/ZipModal';
import PropTypes from 'prop-types';
import { useNavigate, Link } from 'react-router-dom';
import * as _ from 'lodash';

import { CaretDownOutlined, CaretUpOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { Dropdown, Space, Modal} from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { clearUser, getToken } from '../../utils/token';

export default function Header(props) {
  const supressHeaderOptions = window.location.pathname === '/packages' || window.location.pathname === '/storage-box/buying-box' || window.location.pathname.includes('order_confirmation/');
  const orderPage = window.location.pathname === '/packages' || window.location.pathname === '/storage-box/buying-box';
  const showAuthButtons = window.location.pathname.includes('order_confirmation/') || window.location.pathname.includes('/moving-boxes') || window.location.pathname.includes('/storage-boxes')|| window.location.pathname.includes('/my-account');
  
  // const showMyAccountButton = showAuthButtons || 
  //   window.location.pathname === '/packages' || 
  //   window.location.pathname.startsWith('/storage-box/buying-box');

  const element = document.querySelector('._access-icon.material-icons');
  useEffect(() => {

    console.log(element, orderPage)
    if (element) {
      if (orderPage) {
        element.style.opacity = '0';
      } else {
        element.style.opacity = '1';
      }
    }
  }, [orderPage])
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [mobileDropdownOpen, setMobileDropdownOpen] = useState(false);
  const [resourcesDropdownOpen, setResourcesDropdownOpen] = useState(false);
  const [mobileResourcesDropdownOpen, setMobileResourcesDropdownOpen] = useState(false);
  const [customerPortalDropdownOpen, setCustomerPortalDropdownOpen] = useState(false);
  const [customerPortalInfoModalOpen, setCustomerPortalInfoModalOpen] = useState(false);

  const [openZipModal, setZipModal] = React.useState(false);

  const [toggleModal, setToggleModal] = React.useState(true);

  const { user } = useSelector((state) => state.auth);
  const loginToken = getToken();


  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [menuOpen]);

  const logout = async () => {
    dispatch({ type: 'SET_CUSTOMER', data: {} });
    clearUser();
    navigate('/');
  };

  const hideZipM = () => {
    setZipModal(false);
  };

  const showZipModal = () => {
    setZipModal(true);
    setOpen(false);
    setMobileDropdownOpen(false);
    setResourcesDropdownOpen(false);
    setMobileResourcesDropdownOpen(false);
  };
  function toggleModalFunction(argu) {
    setToggleModal(argu);
  }

  const items = [
    // {
    //   label: '•  How it Works',
    //   path: '/moving-boxes',
    //   key: '1'
    // },
    {
      label: '•  Moving Supplies',
      path: '/movingsupplies',
      key: '2'
    },
    {
      label: '•  Packing Supplies',
      path: '/packingsupplies',
      key: '3'
    },
    {
      label: '•  Pricing',
      path: '/pricing',
      key: '4'
    }
  ];

  const resourcesItems = [
    {
      label: '•  Service Area',
      path: '/location',
      key: '1'
    },
    {
      label: '•  Reviews',
      path: '/reviews',
      key: '2'
    },
    {
      label: '•  Referral Program',
      path: '/refer',
      key: '3'
    }
  ];

  const handleMenuClick = (e) => {
    e?.domEvent?.stopPropagation();
    let menuItem = _.find(items, { key: e.key });
    if (menuItem) {
      navigate(menuItem.path);
    }
    setMenuOpen(false);
    setOpen(false);
    setMobileDropdownOpen(false);
  };

  const handleResourcesMenuClick = (e) => {
    e?.domEvent?.stopPropagation();
    let menuItem = _.find(resourcesItems, { key: e.key });
    if (menuItem) {
      navigate(menuItem.path);
    }
    setMenuOpen(false);
    setResourcesDropdownOpen(false);
    setMobileResourcesDropdownOpen(false);
  };

  const handleOpenChange = (flag) => {
    setOpen(flag);
  };

  const handleResourcesDropdownChange = (flag) => {
    setResourcesDropdownOpen(flag);
  };

  const handleCustomerPortalDropdownChange = (flag) => {
    setCustomerPortalDropdownOpen(flag);
  };

  return (
    <>
      <ZipCode
        showModal={openZipModal}
        hideModal={hideZipM}
        toggleModal={toggleModal}
        toggleModalFunction={toggleModalFunction}
        showHideHeader={props.showHideHeader}
        setShowHideHeader={props.setShowHideHeader}
        showHideFooter={props.showHideFooter}
        setshowHideFooter={props.setshowHideFooter}
        showHideinnerFooter={props.showHideinnerFooter}
        setshowHideinnerFooter={props.setshowHideinnerFooter}
        storeStatus={props.storeStatus}
        storeStatusMessage={props.storeStatusMessage}

      //  values={props.values}
      //  setValues={props.setValues}

      //  zipcode={zipcode}
      //  setZipcode={setZipcode}
      />

      <Modal
        open={customerPortalInfoModalOpen}
        onCancel={() => setCustomerPortalInfoModalOpen(false)}
        footer={null}
        centered
        className="customer-portal-info-modal">
        <div className="customer-portal-info-modal-content">
          <h4>Customer Portal Information</h4>
          <p>Our Customer Portal is now live! It will only work with new orders placed on or after September 22, 2025. If you placed an order before that time, please call, text or email us if you&apos;d like to make any changes to your order.</p>
        </div>
      </Modal>

      <div className={`header${(menuOpen && !supressHeaderOptions) ? ' header-full' : ''}${supressHeaderOptions ? ' header-suppressed' : ''}`}>
        <nav
          className={
            supressHeaderOptions
              ? `navbar navbar-expand-lg navbar-light px-0 d-flex ${
                  // For order_confirmation pages, always show space between logo and auth buttons
                  (showAuthButtons && window.location.pathname.includes('order_confirmation/')) ||
                  loginToken 
                    ? 'justify-content-between' 
                    : 'justify-content-center'
                } header-suppressed`
              : 'navbar navbar-expand-lg navbar-light px-0'
          }>
          <Link className="navbar-brand m-0" to="/">
            <img
              src="img/blueboxlogo.png"
              className="logo img-fluid"
              alt="somethinglogo"
              width="100"
              height="100"
            />
          </Link>
          {!supressHeaderOptions ? (
            <>
              {/* <button
                className="navbar-toggler"
                onClick={(e) => {
                  setMenuOpen(!menuOpen);
                }}>
                <span className="navbar-toggler-icon"></span>
              </button> */}
              {!menuOpen && (
                <button
                  className="navbar-toggler"
                  onClick={() => {
                    setMenuOpen(!menuOpen);
                  }}>
                  <span className="navbar-toggler-icon"></span>
                </button>
              )}
              {menuOpen && (
                <button
                  className="navbar-toggler navbar-cancel-btn"
                  onClick={() => {
                    setMenuOpen(false);
                    setOpen(false);
                    setMobileDropdownOpen(false);
                    setMobileResourcesDropdownOpen(false);
                  }}>
                  ✕
                </button>
              )}
              <div
                className={`${menuOpen ? 'collapse navbar-collapse show' : 'collapse navbar-collapse'}`}
                id="navbarSupportedContent"
                hidden={supressHeaderOptions}>
                <ul
                  className="navbar-nav navbar-nave-new ml-auto align-items-center"
                  style={{ flexWrap: 'nowrap' }}>

                   {/* Desktop: Show as dropdown */}
                  <li className="nav-item d-none d-lg-block">
                    <Dropdown
                      menu={{
                        items,
                        onClick: handleMenuClick
                      }}
                      onOpenChange={handleOpenChange}
                      open={open}
                      overlayClassName="header-rent-boxes-dropdown">
                      <a onClick={() => navigate('/moving-boxes')}>
                        <Space className="align-content-center">
                          <span className="text-white fs-15 mr-1">Rent Moving Boxes</span>
                          <span onClick={(e) => {
                            e.stopPropagation();
                            setOpen(!open);
                          }}>
                            {open ? (
                              <CaretUpOutlined style={{ color: 'white' }} />
                            ) : (
                              <CaretDownOutlined style={{ color: 'white' }} />
                            )}
                          </span>
                        </Space>
                      </a>
                    </Dropdown>
                  </li>

                  {/* Mobile: Show as expandable menu section with separated click handlers */}
                  <li className="nav-item d-lg-none">
                    <div className="nav-link text-white fs-15 d-flex justify-content-between align-items-center">
                      <span 
                        className="mobile-nav-text"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();

                          navigate('/moving-boxes');

                          setMenuOpen(false);
                          setMobileDropdownOpen(false);
                        }}>
                        Rent Moving Boxes
                      </span>

                      <span 
                        className="dropdown-arrow-mobile"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          
                          setMobileDropdownOpen(prev => {
                            return !prev;
                          });
                        }}>
                        {mobileDropdownOpen ? (
                          <CaretUpOutlined style={{ color: 'white' }} />
                        ) : (
                          <CaretDownOutlined style={{ color: 'white' }} />
                        )}
                      </span>
                    </div>
                    
                    {/* Show sub-items when expanded - use mobileDropdownOpen */}
                    {mobileDropdownOpen && (
                      <ul className="mobile-submenu">
                        {items.map((item, index) => (
                          <li key={index} className="nav-item">
                            <a
                              className="nav-link"
                              href="#"
                              onTouchStart={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                              }}
                              onTouchEnd={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                
                                setMenuOpen(false);
                                setMobileDropdownOpen(false);

                                setTimeout(() => {
                                  navigate(item.path);
                                }, 100);
                              }}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                
                                setMenuOpen(false);
                                setMobileDropdownOpen(false);
                                navigate(item.path);
                              }}>
                              {item.label.replace('•  ', '')}
                            </a>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>

                  <li className="nav-item">
                    <a
                      className="nav-link text-white fs-15"
                      onClick={(e) => {
                        e.stopPropagation();
                        setMenuOpen(false);
                        setMobileDropdownOpen(false);
                        setMobileResourcesDropdownOpen(false);
                        navigate('/storage-boxes');
                      }}>
                      Storage On-Demand
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link text-white fs-15"
                      onClick={(e) => {
                        e.stopPropagation();
                        setMenuOpen(false);
                        setMobileDropdownOpen(false);
                        setMobileResourcesDropdownOpen(false);
                        navigate('/business');
                      }}>
                      BlueBox For Business
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link text-white fs-15"
                      onClick={(e) => {
                        e.stopPropagation();
                        setMenuOpen(false);
                        setMobileDropdownOpen(false);
                        setMobileResourcesDropdownOpen(false);
                        navigate('/about');
                      }}>
                      About Us
                    </a>
                  </li>

                  {/* Desktop: Resources dropdown */}
                  <li className="nav-item d-none d-lg-block">
                    <Dropdown
                      menu={{
                        items: resourcesItems,
                        onClick: handleResourcesMenuClick
                      }}
                      onOpenChange={handleResourcesDropdownChange}
                      open={resourcesDropdownOpen}
                      overlayClassName="header-resources-dropdown">
                      <a onClick={(e) => e.preventDefault()}>
                        <Space className="align-content-center">
                          <span className="text-white fs-15 mr-1">Resources</span>
                          <span onClick={(e) => {
                            e.stopPropagation();
                            setResourcesDropdownOpen(!resourcesDropdownOpen);
                          }}>
                            {resourcesDropdownOpen ? (
                              <CaretUpOutlined style={{ color: 'white' }} />
                            ) : (
                              <CaretDownOutlined style={{ color: 'white' }} />
                            )}
                          </span>
                        </Space>
                      </a>
                    </Dropdown>
                  </li>

                  {/* Mobile: Resources expandable menu section */}
                  <li className="nav-item d-lg-none">
                    <div className="nav-link text-white fs-15 d-flex justify-content-between align-items-center">
                      <span
                        className="mobile-nav-text"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setMobileResourcesDropdownOpen(prev => !prev);
                        }}>
                        Resources
                      </span>

                      <span
                        className="dropdown-arrow-mobile"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setMobileResourcesDropdownOpen(prev => !prev);
                        }}>
                        {mobileResourcesDropdownOpen ? (
                          <CaretUpOutlined style={{ color: 'white' }} />
                        ) : (
                          <CaretDownOutlined style={{ color: 'white' }} />
                        )}
                      </span>
                    </div>

                    {/* Show sub-items when expanded */}
                    {mobileResourcesDropdownOpen && (
                      <ul className="mobile-submenu">
                        {resourcesItems.map((item, index) => (
                          <li key={index} className="nav-item">
                            <a
                              className="nav-link"
                              href="#"
                              onTouchStart={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                              }}
                              onTouchEnd={(e) => {
                                e.preventDefault();
                                e.stopPropagation();

                                setMenuOpen(false);
                                setMobileResourcesDropdownOpen(false);

                                setTimeout(() => {
                                  navigate(item.path);
                                }, 100);
                              }}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();

                                setMenuOpen(false);
                                setMobileResourcesDropdownOpen(false);
                                navigate(item.path);
                              }}>
                              {item.label.replace('•  ', '')}
                            </a>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>

                  <li className="nav-item">
                    <a
                      className="nav-link text-white fs-15"
                      onClick={(e) => {
                        e.stopPropagation();
                        setMenuOpen(false);
                        setMobileDropdownOpen(false);
                        setMobileResourcesDropdownOpen(false);
                        navigate('/contactus');
                      }}>
                      Contact Us
                    </a>
                  </li>
                  <li className="nav-item" hidden={!loginToken}>
                    <a
                      className="nav-link text-white cursor-pointer d-flex align-items-center"
                      onClick={(e) => {
                        e.stopPropagation();
                        setMenuOpen(false);
                        setMobileDropdownOpen(false);
                        setMobileResourcesDropdownOpen(false);
                        navigate('/my-account?tab=account');
                      }}>
                      <img
                        className="img-fluid mr-1"
                        src="svg/my-account.svg"
                        style={{ height: '19px' }}
                      />
                      <span className="fs-15">My Account</span>
                    </a>
                  </li>
                  {/*(Desktop - Hover Dropdown): Currently ACTIVE for desktop */}
                  <li className="nav-item d-none d-lg-block" hidden={loginToken || supressHeaderOptions}>
                    <Dropdown
                      dropdownRender={() => (
                        <div className="customer-portal-dropdown-content">
                          <p>Our Customer Portal is now live! It will only work with new orders placed on or after September 22, 2025. If you placed an order before that time, please call, text or email us if you&apos;d like to make any changes to your order.</p>
                        </div>
                      )}
                      onOpenChange={handleCustomerPortalDropdownChange}
                      open={customerPortalDropdownOpen}
                      overlayClassName="header-customer-portal-dropdown">
                      <a
                        className="nav-link text-white cursor-pointer d-flex align-items-center"
                        onClick={(e) => {
                          e.stopPropagation();
                          setMenuOpen(false);
                          setCustomerPortalDropdownOpen(false);
                          setMobileResourcesDropdownOpen(false);
                          navigate('/login');
                        }}>
                        <img className="img-fluid mr-1" src="svg/logout.svg" width="19" height="19" />
                        <span className="fs-15">Customer Portal</span>
                      </a>
                    </Dropdown>
                  </li>

                  {/*(Mobile - Info Icon with Modal): Currently ACTIVE for mobile */}
                  <li className="nav-item d-lg-none" hidden={loginToken || supressHeaderOptions}>
                    <div className="nav-link text-white d-flex align-items-center justify-content-between customer-portal-mobile-wrapper">
                      <a
                        className="cursor-pointer d-flex align-items-center flex-grow-1"
                        onClick={(e) => {
                          e.stopPropagation();
                          setMenuOpen(false);
                          setMobileResourcesDropdownOpen(false);
                          navigate('/login');
                        }}>
                        <img className="img-fluid mr-1" src="svg/logout.svg" width="19" height="19" />
                        <span className="fs-15">Customer Portal</span>
                      </a>
                      <InfoCircleOutlined
                        className="customer-portal-info-icon"
                        onClick={(e) => {
                          e.stopPropagation();
                          setCustomerPortalInfoModalOpen(true);
                        }}
                      />
                    </div>
                  </li>
                  <li className="nav-item" hidden={!loginToken}>
                    <a className="nav-link text-white cursor-pointer d-flex align-items-center" onClick={logout}>
                      <img className="img-fluid mr-1" src="svg/logout.svg" width="19" height="19" />
                      <span className="fs-15">Logout</span>
                    </a>
                  </li>
                  <li className="nav-item order-now">
                    <a
                      className="nav-link text-white py-1 btn btn-dark fs-15 fw-500"
                      style={{ 
                        lineHeight: '31px', 
                        borderRadius: '5px',
                        whiteSpace: 'nowrap',
                        minWidth: '100px'
                      }}
                      onClick={() => {
                        showZipModal();
                        setToggleModal(true);
                      }}>
                      Order Now
                    </a>
                  </li>
                </ul>
              </div>
            </>
          ) : (
            // Show auth buttons based on showAuthButtons logic for order_confirmation pages
            (showAuthButtons && window.location.pathname.includes('order_confirmation/')) ? (
              <div className="d-flex justify-content-start">
                <ul className="navbar-nav flex-row align-items-center mb-0 login-link">
                  {/* Show My Account and Logout if user is logged in */}
                  <li className="nav-item mx-2" hidden={!loginToken}>
                    <a
                      className="nav-link text-white cursor-pointer d-flex align-items-center"
                      onClick={(e) => {
                        e.stopPropagation();
                        setMenuOpen(false);
                        navigate('/my-account?tab=account');
                      }}>
                      <img
                        className="img-fluid mr-1"
                        src="svg/my-account.svg"
                        style={{ height: '19px' }}
                      />
                      <span className="fs-15">My Account</span>
                    </a>
                  </li>
                  <li className="nav-item mx-2" hidden={!loginToken}>
                    <a className="nav-link text-white cursor-pointer d-flex align-items-center" onClick={logout}>
                      <img className="img-fluid mr-1" src="svg/logout.svg" width="19" height="19" />
                      <span className="fs-15">Logout</span>
                    </a>
                  </li>
                  {/* (Desktop - Hover Dropdown): Currently ACTIVE for desktop */}
                  <li className="nav-item mx-2 d-none d-lg-flex" hidden={loginToken}>
                    <Dropdown
                      dropdownRender={() => (
                        <div className="customer-portal-dropdown-content">
                          <p>Our Customer Portal is now live! It will only work with new orders placed on or after September 22, 2025. If you placed an order before that time, please call, text or email us if you&apos;d like to make any changes to your order.</p>
                        </div>
                      )}
                      onOpenChange={handleCustomerPortalDropdownChange}
                      open={customerPortalDropdownOpen}
                      overlayClassName="header-customer-portal-dropdown">
                      <a
                        className="nav-link text-white cursor-pointer d-flex align-items-center"
                        onClick={(e) => {
                          e.stopPropagation();
                          setMenuOpen(false);
                          setCustomerPortalDropdownOpen(false);
                          navigate('/login');
                        }}>
                        <img className="img-fluid mr-1" src="svg/logout.svg" width="19" height="19" />
                        <span className="fs-15">Customer Portal</span>
                      </a>
                    </Dropdown>
                  </li>

                  {/*(Mobile - Info Icon with Modal): Currently ACTIVE for mobile */}
                  <li className="nav-item mx-2 d-lg-none" hidden={loginToken}>
                    <div className="nav-link text-white d-flex align-items-center customer-portal-mobile-wrapper">
                      <a
                        className="cursor-pointer d-flex align-items-center flex-grow-1"
                        onClick={(e) => {
                          e.stopPropagation();
                          setMenuOpen(false);
                          navigate('/login');
                        }}>
                        <img className="img-fluid mr-1" src="svg/logout.svg" width="19" height="19" />
                        <span className="fs-15">Customer Portal</span>
                      </a>
                      <InfoCircleOutlined
                        className="customer-portal-info-icon"
                        onClick={(e) => {
                          e.stopPropagation();
                          setCustomerPortalInfoModalOpen(true);
                        }}
                      />
                    </div>
                  </li>
                </ul>
              </div>
            ) : (
              // Original logic: only show auth buttons if user is logged in (for non-order_confirmation pages)
              loginToken && (
                <div className="d-flex justify-content-start">
                  <ul className="navbar-nav flex-row align-items-center mb-0 login-link">
                  <li className="nav-item mx-2" hidden={!loginToken}>
                    <a
                      className="nav-link text-white cursor-pointer d-flex align-items-center"
                      onClick={(e) => {
                        e.stopPropagation();
                        setMenuOpen(false);
                        navigate('/my-account?tab=account');
                      }}>
                      <img
                        className="img-fluid mr-1"
                        src="svg/my-account.svg"
                        style={{ height: '19px' }}
                      />
                      <span className="fs-15">My Account</span>
                    </a>
                  </li>
                  <li className="nav-item mx-2" hidden={!loginToken}>
                    <a className="nav-link text-white cursor-pointer d-flex align-items-center" onClick={logout}>
                      <img className="img-fluid mr-1" src="svg/logout.svg" width="19" height="19" />
                      <span className="fs-15">Logout</span>
                    </a>
                  </li>
                  </ul>
                </div>
              )
            )
          )}
        </nav>
      </div>
    </>
  );
}

Header.propTypes = {
  showHideHeader: PropTypes.any,
  setShowHideHeader: PropTypes.any,
  showHideFooter: PropTypes.any,
  setshowHideFooter: PropTypes.any,
  showHideinnerFooter: PropTypes.any,
  setshowHideinnerFooter: PropTypes.any,
  zipCodeSection: PropTypes.any,
  scrollToSection: PropTypes.any,
  showZipModal: PropTypes.any,
  storeStatus: PropTypes.any,
  storeStatusMessage: PropTypes.any,
  supressHeaderOptions: PropTypes.any
};